interface ProjectDragOverlayProps {
  name: string;
  itemCount: number;
  subtotal: number;
}

export function ProjectDragOverlay({ name, itemCount, subtotal }: ProjectDragOverlayProps) {
  return (
    <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-indigo-50 border border-indigo-300 rounded-md shadow-lg text-xs max-w-[280px]">
      <span className="font-semibold text-indigo-900 truncate">{name}</span>
      <span className="text-indigo-600 bg-indigo-100 px-1.5 py-0.5 rounded whitespace-nowrap">
        {itemCount} item{itemCount !== 1 ? 's' : ''}
      </span>
      <span className="font-semibold text-indigo-700 whitespace-nowrap ml-auto">
        ${subtotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
      </span>
    </div>
  );
}
